export default __webpack_public_path__ + "static/media/5C3B142A-60CE-4F32-94E0-D0BF699F9ED9_1_105_c.9b9e8688.jpeg";